<template lang="pug">
  .verification(v-if="data.step=='verification'")
    .verification__wr
      .verification__left
        .verification__items(v-if="data.order")
          .verification__item-wr(v-for="item in data.order", :key="item.id")
            .verification__item
              .verification__item-left(:data-src="item.image")
                img.verification__item-img.verification__item-img--hide(v-if="item.image", :src="item.image")
              .verification__item-right
                .verification__item-name(v-if="item.name") {{item.name}}
                .verification__item-bottom
                  .verification__item-bottom-left
                    .verification__item-size(v-if="item.size") {{item.size}}
                    .verification__item-count(v-if="item.count") {{item.count}} шт.
                  .verification__item-price(v-if="item.price") {{item.price.value}}
                    span {{item.price.currency}}
      .verification__right
        .verification__right-box-wr
          .verification__right-box
            .verification__right-title Контактные данные
            .verification__right-row(v-if="data.contacts.name")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/name.svg")
                |Имя
              .verification__right-value {{data.contacts.name}}
            .verification__right-row(v-if="data.contacts.email")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/email.svg")
                |E-mail
              .verification__right-value {{data.contacts.email}}
            .verification__right-row(v-if="data.contacts.phone")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/phone.svg")
                |Телефон
              .verification__right-value {{data.contacts.phone}}
            .verification__right-row(v-if="data.contacts.count_persons")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/count.svg")
                |Колличество персон
              .verification__right-value {{data.contacts.count_persons}}
            .verification__right-row(v-if="data.contacts.street")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/street.svg")
                |Адрес доставки
              .verification__right-value #[strong ул.] {{data.contacts.street}}
                | #[span(v-if="data.contacts.home") , #[strong д.] {{data.contacts.home}}]
                | #[span(v-if="data.contacts.porch") , #[strong под.] {{data.contacts.porch}}]
                | #[span(v-if="data.contacts.floor") , #[strong эт.] {{data.contacts.floor}}]
                | #[span(v-if="data.contacts.apartment") , #[strong кв.] {{data.contacts.apartment}}]
            .verification__right-row.verification__right-row--comment(v-if="data.contacts.comment")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/comment.svg")
                |Комментарии
              .verification__right-value {{data.contacts.comment}}
              .verification__right-btn-more(v-if="data.contacts.comment.length > 190", @click="showComment($event)") Читать дальше
            .verification__right-row(v-if="data.contacts.payment_method")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/pay.svg")
                |Способ оплаты
              .verification__right-value {{data.contacts.payment_method}}
            .verification__right-row.verification__right-row--sum(v-if="data.sum")
              .verification__right-param
                img.verification__right-param-ico(src="~@/assets/img/rub.svg")
                | Итого к оплате
              .verification__right-value
                .verification__right-value-left Товары ({{data.count}})
                .verification__right-value-right {{data.sum.value}}
                  span {{data.sum.currency}}
          button.verification__btn-next(v-if="data.orderBtnTitle", @click="checkoutLocal") {{data.orderBtnTitle}}
        router-link.verification__btn-back(to="/korzina/vash-zakaz") Изменить заказ
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/verification/verification.styl';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
  import {CartHelpersVue} from '@/mixins/CartHelpersVue';
  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';

  // @ is an alias to /src
  //import Events from '@/components/events/Events.vue';

export default {
  name: 'Verification',

  mixins: [AjaxHelpersVue, ImagePreloaderVue, CartHelpersVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  data() {
    return {

    }
  },

  components: {
    SvgIcon
    //Events
  },

  created() {
    this.$nextTick(() => {
      this.imgPreloader('verification__item-left', 'verification__item-img', '', 250);
    });
  },

  methods: {
    showComment(e) {
      let height = $(e.target).prev().css({'height': 'auto'}).height();

      $(e.target).hide().prev().css({'height': ''}).stop().animate({'height': height + 'px'}, {
        duration: 250,
        progress: function() {
          $('.cart__items').css('height', $('.cart__item--active').find('.cart__item-content').outerHeight() + 'px');
          $('.page__items').css('height', $('.page__item--active').outerHeight() + 'px');
        }
      });
    },

    checkoutLocal() {
      this.checkout((res) => {
        if(this.checkProperty(this.checkProperty(res.status) && res.status === 'ok')) {
          if(res.paymentLink !== "") {
            window.open(res.paymentLink, '_blank');
          }
          this.cartStep('/korzina/vypolnenie');
        }
      });
    }
  }
}
</script>
